import { IoHandLeft } from "react-icons/io5";
import dealer_icon from "../../../../../../../../assets/games/Truco/dealer_icon.png"
import { forwardRef, memo, useState } from "react"

export const DealerIcon = memo(forwardRef(({ className, getDealerIconPosition, currentDealer }, ref) => {
    const { x, y } = getDealerIconPosition(currentDealer)
    return (
        <img
            ref={ref}
            src={dealer_icon}
            id="truco-dealer-icon-img"
            className={`truco-dealer-icon-img ${className}`}
            draggable="false"
            style={{ top: y, left: x }}
        />
        // <div className={`truco-dealer-icon-img ${className}`}
        //     draggable="false" style={{ top: y, left: x }} >
        //     <IoHandLeft />
        // </div>
    )
}))
